shvenergy.wallpaper = (function ($) {
	"use strict";

	function init() {
        const body = document.querySelector('body');
        const parallaxForce = 1.5; // Higher number means slower 

        document.addEventListener('scroll', () => {
            const y = (window.scrollY > 0) ? (window.scrollY / parallaxForce) : 0;
            
            body.style.backgroundPositionY = `${y}px`;
        });
    }

    init();
})(jQuery);